import { createContext, useContext, useState, ReactNode } from "react";

interface AdminPageTitleContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

export const AdminPageTitleContext = createContext<AdminPageTitleContextType>({
  pageTitle: "Dashboard",
  setPageTitle: () => {},
});

export const useAdminPageTitle = () => useContext(AdminPageTitleContext);

interface AdminPageTitleProviderProps {
  children: ReactNode;
}

export const AdminPageTitleProvider = ({
  children,
}: AdminPageTitleProviderProps) => {
  const [pageTitle, setPageTitle] = useState("Dashboard");

  return (
    <AdminPageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </AdminPageTitleContext.Provider>
  );
};